import BasePointManager from "../../../../../../src/managers/BasePointManager";
import AngleManager from "../AngleManager/AngleManager";
import LineManager from "../LineManager";
import { DrawLinesAnim, MoveAngles, PointAnim, RotateAngle } from "./helpers/drawHelpers";


interface ContextType {
  LineManager: LineManager,
  PointManager: BasePointManager,
  AngleManager: AngleManager
}


export function runAnimation(context: ContextType, isActive: boolean) {
  isActive ? onSupplementaryMode(context) : offSupplementaryMode(context);
}

export async function onSupplementaryMode(context: ContextType) {
  const {
    LineManager,
    PointManager,
    AngleManager,
  } = context;

  const redPoints = PointManager.getRedPoints();
  const pointCoords = redPoints.map(r => ({ x: r.x, y: r.y }))
  const angles = AngleManager.getAngles();
  const lC = LineManager.getGuideLinesCoords(pointCoords);
  const rots = [ -Math.PI / 180 * angles[3].degree, Math.PI / 180 * angles[0].degree ]

  await PointAnim([redPoints[0], redPoints[3]], false);
  await DrawLinesAnim([LineManager.guideLine1, LineManager.guideLine2], lC, false)
  await MoveAngles([angles[0], angles[3]], [pointCoords[2], pointCoords[1]]);
  await RotateAngle([angles[0], angles[3]], rots);
}

export async function offSupplementaryMode(context: ContextType) {
  const {
    LineManager,
    PointManager,
    AngleManager,
  } = context;

  const redPoints = PointManager.getRedPoints();
  const pointCoords = redPoints.map(r => ({ x: r.x, y: r.y }))
  const angles = AngleManager.getAngles();
  const lC = LineManager.getGuideLinesCoords(pointCoords);
  const _rots = [
    -Math.PI / 180 * angles[3].degree,
    Math.PI / 180 * angles[0].degree,
  ]
  const rots = angles[0].rotation == 0 && angles[3].rotation == 0 ? _rots : [0, 0];

  await MoveAngles([angles[0], angles[3]], [pointCoords[0], pointCoords[3]]);
  await RotateAngle([angles[0], angles[3]], rots);
  await DrawLinesAnim([LineManager.guideLine1, LineManager.guideLine2], lC, true)
  await PointAnim([redPoints[0], redPoints[3]], true);
}